import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="p-8 text-brand-mute">Loading…</div>;
    if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
};
